import { Component, OnDestroy, OnInit } from '@angular/core';
import { MapService } from '../../../../../shared/layout/fap_main-map/service/map-service';
import { WidgetsService } from '../../../../../core/services/api/widgets/widgets.service';

@Component({
  templateUrl: './pools-container.component.html',
  styleUrls: ['./pools-container.component.scss']
})
export class PoolsContainerComponent implements OnInit, OnDestroy {

  public pools = []

  constructor(private mapService: MapService, public widgetService: WidgetsService) { }

  ngOnInit(): void {
    this.widgetService.setSize(12);
    this.mapService.hideMap();
  }

  ngOnDestroy(): void {
    this.widgetService.setSize(6);
  }

}
